import { Auth } from 'aws-amplify';
import config from '../config';

// API endpoint URL for the content management API
const API_ENDPOINT = config.api.url;

// Submit a question
export async function submitQuestion(title, question, track = 'general') {
  try {
    // Get current authenticated user
    const user = await Auth.currentAuthenticatedUser();
    const userId = user.attributes.sub;
    const username = user.attributes.email || user.username;
    
    // Prepare question data
    const questionData = {
      userId,
      username,
      title,
      question,
      track
    };
    
    // Call the API
    const response = await fetch(`${API_ENDPOINT}questions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(questionData),
    });
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error submitting question:', error);
    throw error;
  }
}

// Get user questions
export async function getUserQuestions() {
  try {
    // Get current authenticated user
    const user = await Auth.currentAuthenticatedUser();
    const userId = user.attributes.sub;
    
    // Call the API
    const response = await fetch(`${API_ENDPOINT}questions/${userId}`);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    const data = await response.json();
    return data.questions || [];
  } catch (error) {
    console.error('Error fetching user questions:', error);
    throw error;
  }
}

// Get public questions
export async function getPublicQuestions(track = null) {
  try {
    // Build URL with optional track parameter
    let url = `${API_ENDPOINT}questions/public`;
    if (track) {
      url += `?track=${encodeURIComponent(track)}`;
    }
    
    // Call the API
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    const data = await response.json();
    return data.questions || [];
  } catch (error) {
    console.error('Error fetching public questions:', error);
    throw error;
  }
}
